// pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';

const Home = () => {
  return (
    <div className={styles.wrapper}>
      {/* Prvi sloj - Naslov */}
      <div className={styles.titleLayer}>
        <div className={styles.contentContainer}>
          <h1 className={styles.pageTitle}>Povećanje vrijednosti i prodaja kompanije</h1>
        </div>
      </div>
      
      {/* Drugi sloj - Kartice */}
      <div className={styles.pageContent}>
        <div className={styles.contentContainer}>
          <div className={styles.serviceGrid}>
            {/* Blog kartica */}
            <Link to="/blog" className={styles.serviceCard}>
              <h2 className={styles.serviceCardTitle}>Blog</h2>
              <p className={styles.serviceCardDescription}>
                Savjeti i tekstovi u vezi povećanja vrijednosti i prodaje kompanije
              </p>
            </Link>
            
            {/* Prodaja kompanije kartica */}
            <Link to="/ksb" className={styles.serviceCard}>
              <h2 className={styles.serviceCardTitle}>Prodaja kompanije</h2>
              <p className={styles.serviceCardDescription}>
                Posredovanje i savjetovanje kod povećanja vrijednosti i prodaje kompanije
              </p>
            </Link>
            
            {/* Kontakt kartica */}
            <Link to="/kontakt" className={styles.serviceCard}>
              <h2 className={styles.serviceCardTitle}>Kontakt</h2>
              <p className={styles.serviceCardDescription}>
                Kontaktirajte nas za konsultacije i više informacija
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;